import React, { memo } from 'react';

import { format } from 'date-fns';
import locale from 'date-fns/locale/pt-BR';

import { CircleBorder, Container, Content, StatusTitulo, StepTexto } from './styles';

const Steps = ({ steps = [] }) => (
  <div>
    <StatusTitulo>Status do serviço</StatusTitulo>
    <Container>
      {steps.map(({ name, isCompleted, date }, index) => (
        <Content key={String(index)}>
          <CircleBorder>{isCompleted && <div />}</CircleBorder>
          <StepTexto>
            {name}
            <br />
            {date && (
              <>
                <span id='date'>{format(date, 'dd/MM/yy', { locale })}</span>
                <span id='date'>{format(date, "'às' H'h'mm", { locale })}</span>
              </>
            )}
          </StepTexto>
        </Content>
      ))}
    </Container>
  </div>
);

export default memo(Steps);
